function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0.5C3.85742 0.5 0.5 3.85742 0.5 8V15.0312C0.5 15.291 0.708984 15.5 0.96875 15.5H4.5625C5.25195 15.5 5.8125 14.9395 5.8125 14.25V10.1875C5.8125 9.49805 5.25195 8.9375 4.5625 8.9375H1.90625V8C1.90625 4.63477 4.63477 1.90625 8 1.90625C11.3652 1.90625 14.0938 4.63477 14.0938 8V8.9375H11.4375C10.748 8.9375 10.1875 9.49805 10.1875 10.1875V14.25C10.1875 14.9395 10.748 15.5 11.4375 15.5H15.0312C15.291 15.5 15.5 15.291 15.5 15.0312V8C15.5 3.85742 12.1426 0.5 8 0.5ZM4.40625 10.3438V14.0938H1.90625V10.3438H4.40625ZM14.0938 14.0938H11.5938V10.3438H14.0938V14.0938Z",
  fill: "currentColor"
});

var SvgIconSupport = function SvgIconSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_support.614674be.svg";
export { ForwardRef as ReactComponent };